module.exports = __webpack_public_path__ + "static/cpp-logo-1707cdd2653343a23bd229fb71ad7798.png";